import { render, staticRenderFns } from "./CharacteristicDeferredAmountTable.vue?vue&type=template&id=d0b12b00&"
import script from "./CharacteristicDeferredAmountTable.vue?vue&type=script&lang=ts&"
export * from "./CharacteristicDeferredAmountTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports